export function detectNewline(str) {
  if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	let newlines = (str.match(/(?:\r?\n)/g) || []);

	if (newlines.length === 0) {
		return null;
	}

	let crlf = newlines.filter(function (el) {
		return el === '\r\n';
	}).length;

	let lf = newlines.length - crlf;

	return crlf > lf ? '\r\n' : '\n';
}
